import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#071A33] text-white" data-testid="site-footer">
      <div className="container-phs py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img
              src="/images/logo-dark.png"
              alt="Park Home Support"
              className="h-24 w-auto -ml-2 mb-5"
              width={400}
              height={270}
            />
            <p className="text-sm text-white/70 leading-relaxed max-w-xs">
              Practical, specialist support, quote review, inspection guidance and insurance-related technical guidance for park home owners and operators.
            </p>
            <p className="mt-4 text-xs text-white/50">
              Park Home Support is not insurance and is not a warranty.
            </p>
          </div>

          <div>
            <h4 className="text-sm tracking-[0.22em] uppercase text-[#B88A2A] mb-5 font-body font-medium">Owners</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li><Link to="/quote-review" className="hover:text-white">Quote Review</Link></li>
              <li><Link to="/insurance" className="hover:text-white">Insurance Guidance</Link></li>
              <li><Link to="/inspections" className="hover:text-white">Inspections</Link></li>
              <li><Link to="/support-plan" className="hover:text-white">Support Plan</Link></li>
              <li><Link to="/membership" className="hover:text-white">Join Now</Link></li>
              <li><Link to="/my-health-checks" className="hover:text-white" data-testid="footer-my-health-checks">My Health Checks</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm tracking-[0.22em] uppercase text-[#B88A2A] mb-5 font-body font-medium">Company</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/operators" className="hover:text-white">For Park Operators</Link></li>
              <li><Link to="/pay" className="hover:text-white">Pay an Invoice</Link></li>
              <li><Link to="/how-it-works" className="hover:text-white">How It Works</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm tracking-[0.22em] uppercase text-[#B88A2A] mb-5 font-body font-medium">Get in Touch</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2.5"><Mail size={16} className="mt-0.5 text-[#B88A2A]" /> advice@parkhomesupport.co.uk</li>
              <li className="flex items-start gap-2.5"><Phone size={16} className="mt-0.5 text-[#B88A2A]" /> <a href="tel:+443335776047" className="hover:text-white transition" data-testid="footer-phone-link">0333 577 6047</a></li>
              <li className="flex items-start gap-2.5"><MapPin size={16} className="mt-0.5 text-[#B88A2A]" /> United Kingdom</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/60">
          <p>© {new Date().getFullYear()} Park Home Support. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
